jQuery(document).ready(function ($) {
		
   
      $("#youtube-area").addClass('appear');
      $("#loading").addClass('disappear');

    
    //youtube API
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    var ytPlayer;
    function onYouTubeIframeAPIReady() {
        ytPlayer = new YT.Player('youtube', {//動画を表示させたいIDを指定
            videoId: 'm1loYZBmAv4',//動画のアドレスの指定
            playerVars: {
                playsinline: 1,// インライン再生を行う
                autoplay:1,//自動再生を行う
                fs:0,//全画面表示ボタンを表示しない    
                rel: 0,// 再生中の動画と同じチャンネルの関連動画を表示
                controls: 0,// プレーヤー コントロールを表示しない
                modestbranding: 1, // YouTubeロゴの非表示
                iv_load_policy: 3, // アノテーションの非表示
                start:50,//50秒後から動画がスタート
            },    
            events: {//　イベント
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }
    
    //ミュートにしてから再生する設定
    function onPlayerReady(event) {
      event.target.mute();
      event.target.playVideo();
    }
    
    
    //ループ設定
    function onPlayerStateChange(event) {
     if (event.data == YT.PlayerState.ENDED) {
        event.target.playVideo();
      }
    }
    
    
    
    
    
    
	
	$(function () {
        $('.more').click(function () {
            $(this).fadeOut();
            $(this).parent().removeClass("hide");
        });
        $('.heritage-content-closebtn').click(function () {
            $(this).parent().toggleClass("hide");
            $(this).next('.more').fadeIn();
        });
    });

	$('.more-btn-pc').on('click',function(){
		$(this).toggleClass('closed');
		$(this).prev('div.content-wrap').toggleClass('unlimited');
		$(this).parents('.js-u-carousel-kv-single').toggleClass('filtered');
		if($(this).hasClass('closed')){
			$(this).text('× 閉じる');
		}else{
			$(this).text('＋ 続きを読む');
		}
	})
		
	$('.js-product-galleryslick02').slick({
    dots: false,
    speed: 400,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 2000,
      settings: 'unslick'
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10%'
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
  $('.js-gallery').slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: "25%",
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        centerPadding: 0,
        infinite: true
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
  
  $(function(){
	  $("#bg-movie").YTPlayer();
	});
	
	$(function(){
	  $("#bg-sp-movie").YTPlayer();
	});	
		
});


